import {
  ColorPickerPanel,
  RectangularBoxMarkerBase,
  RectangularBoxMarkerBaseState,
  Settings,
  SvgHelper,
  ToolboxPanel,
} from "markerjs2";

export interface TriangleMarkerState extends RectangularBoxMarkerBaseState {
  strokeColor: string;
}

export class TriangleMarker extends RectangularBoxMarkerBase {
  public static typeName = "TriangleMarker";
  public static title = "Triangle marker";
  public static icon = `<svg viewBox="0 0 24 24"><path d="M12,2L1,21H23M12,6L19.53,19H4.47" fill="none" stroke="currentColor" stroke-width="2" /></svg>`;

  protected strokeColor = "transparent";
  protected strokeWidth = 0;
  protected strokePanel: ColorPickerPanel;

  constructor(
    container: SVGGElement,
    overlayContainer: HTMLDivElement,
    settings: Settings
  ) {
    super(container, overlayContainer, settings);

    this.strokeColor = settings.defaultColor;
    this.strokeWidth = settings.defaultStrokeWidth;

    this.createVisual = this.createVisual.bind(this);
    this.setStrokeColor = this.setStrokeColor.bind(this);

    // Instantiate panel here, where `settings` is directly available
    const colors = settings.defaultColorSet || ["#805AD5", "#E53E3E", "#3182CE", "#38A169", "#DD6B20", "#319795", "#D69E2E"];
    this.strokePanel = new ColorPickerPanel(
      "Border color",
      colors,
      this.strokeColor
    );

    this.strokePanel.onColorChanged = (color: string) => {
      this.setStrokeColor(color);
    };
  }

  protected createVisual() {
    this.visual = SvgHelper.createPolygon(this.getPoints(), [
      ["stroke", this.strokeColor],
      ["fill", "transparent"],
      ["stroke-width", this.strokeWidth.toString()],
    ]);
  }

  private getPoints(): string {
    return `${this.width / 2},0 0,${this.height} ${this.width},${this.height}`;
  }

  public setStrokeColor(color: string) {
    this.strokeColor = color;
    if (this.visual) {
      this.visual.setAttribute("stroke", this.strokeColor);
    }
  }

  public get toolboxPanels(): ToolboxPanel[] {
    const panels = super.toolboxPanels || [];
    if (this.strokePanel) {
      panels.push(this.strokePanel);
    }
    return panels;
  }

  public getState(): TriangleMarkerState {
    const state = super.getState() as TriangleMarkerState;
    state.strokeColor = this.strokeColor;
    return state;
  }

  public restoreState(state: TriangleMarkerState) {
    super.restoreState(state);
    this.setStrokeColor(state.strokeColor);
  }
}
